import { handleActions } from "redux-actions";
import { setOnlyOneFileAtTime } from "../actions/actions";

export default handleActions(
  {
    [setOnlyOneFileAtTime]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
